import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { HighlightLogoIcon } from './icon'
import { HIGHLIGHT_LOGO_SIZES, type HighlightLogoSize } from './sizes'

interface HighlightLogoTileProps extends ComponentProps<'span'> {
  size?: HighlightLogoSize
}

/**
 * The symbol on its yellow square: the app icon, and the mark a screen leads with when the word
 * would repeat a title that already says Highlight. The symbol is half the square.
 */
export function HighlightLogoTile({ size = 'md', className, ...props }: HighlightLogoTileProps) {
  const { box, radius } = HIGHLIGHT_LOGO_SIZES[size]
  return (
    <span
      role="img"
      aria-label="Highlight"
      className={twMerge(
        'bg-brand text-on-brand corner-squircle inline-flex items-center justify-center',
        box,
        radius,
        className,
      )}
      {...props}
    >
      <HighlightLogoIcon className="size-1/2" />
    </span>
  )
}
